// extracted by mini-css-extract-plugin
export default {"countdown":"Nia-z","srOnly":"Oia-z"};